import styled from '@emotion/styled';
import { Formik, FormikConfig, FormikProps } from 'formik';
import { ReactNode } from 'react';
import BatchImport from './BatchImport';
import PlatformRegionList from './PlatformRegionList';
import Result from './Result';
import { FV, Store } from './share';
import StoreList from './StoreList';

const Container = styled.div`
  display: flex;
  height: 570px;
  max-height: calc(100vh - 209px);
`;

const Item = styled.div`
  align-items: stretch;
  overflow: auto;
`;

const Left = styled(Item)`
  flex: 0 0 180px;
  border-right: solid 1px #f0f2f5;
`;

const Center = styled(Item)`
  flex: 1 0 0;
`;

const Right = styled(Item)`
  flex: 0 0 250px;
  border-left: solid 1px #f0f2f5;
  > * {
    height: 100%;
  }
`;

export interface StoreScopesFormProps extends FormikConfig<FV> {
  children: (form: ReactNode, props: FormikProps<FV>) => ReactNode;
  departmentId?: number;
  platform?: General.PlatformUpperCaseTunnel;
  permId?: General.PermissionId;
  supportWa?: boolean;
  storeDataSource?: Store[];
  singleRegion?: boolean | string;
  singlePlatform?: boolean | string;
  invalidStoreIds?: {
    storeIds: number[];
    tooltips: string;
  }[];
}

function StoreScopesForm(props: StoreScopesFormProps) {
  const {
    children,
    departmentId,
    platform,
    permId,
    supportWa,
    storeDataSource,
    singleRegion,
    singlePlatform,
    invalidStoreIds,
    ...otherProps
  } = props;

  return (
    <Formik enableReinitialize {...otherProps}>
      {(formProps) => {
        const {
          values: { mode },
        } = formProps;

        const form = (
          <Container>
            {
              {
                platform: (
                  <>
                    <Left>
                      <PlatformRegionList
                        departmentId={departmentId}
                        permId={permId}
                        platform={platform}
                        supportWa={supportWa}
                        storeDataSource={storeDataSource}
                        singleRegion={singleRegion}
                        singlePlatform={singlePlatform}
                      />
                    </Left>
                    <Center>
                      <StoreList
                        departmentId={departmentId}
                        permId={permId}
                        storeDataSource={storeDataSource}
                        invalidStoreIds={invalidStoreIds}
                      />
                    </Center>
                  </>
                ),
                import: (
                  <Center>
                    <BatchImport
                      departmentId={departmentId}
                      permId={permId}
                      supportWa={supportWa}
                      storeDataSource={storeDataSource}
                      singleRegion={singleRegion}
                      singlePlatform={singlePlatform}
                    />
                  </Center>
                ),
              }[mode]
            }
            <Right>
              <Result />
            </Right>
          </Container>
        );

        return children(form, formProps);
      }}
    </Formik>
  );
}

export default StoreScopesForm;
